import type { ReactNode } from "react"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"

interface TicketDetailTabsProps {
  activeTab: string
  onTabChange: (value: string) => void
  historyContent: ReactNode
  overviewContent: ReactNode
  chatContent: ReactNode
}

export function TicketDetailTabs({
  activeTab,
  onTabChange,
  historyContent,
  overviewContent,
  chatContent,
}: TicketDetailTabsProps) {
  return (
    <Tabs value={activeTab} onValueChange={onTabChange} className="w-full h-full flex flex-col">
      <TabsList className="grid w-full grid-cols-3 bg-slate-100 flex-shrink-0">
        <TabsTrigger
          value="history"
          className="data-[state=active]:bg-white data-[state=active]:shadow-sm font-bold"
        >
          対応履歴
        </TabsTrigger>
        <TabsTrigger
          value="overview"
          className="data-[state=active]:bg-white data-[state=active]:shadow-sm font-bold"
        >
          案件概要
        </TabsTrigger>
        <TabsTrigger
          value="chat"
          className="data-[state=active]:bg-white data-[state=active]:shadow-sm font-bold"
        >
          チャット
        </TabsTrigger>
      </TabsList>
      <TabsContent value="history" className="mt-4 space-y-4 flex-1">
        {historyContent}
      </TabsContent>
      <TabsContent value="overview" className="mt-4 flex-1 overflow-auto">
        {overviewContent}
      </TabsContent>
      <TabsContent value="chat" className="mt-4 flex-1 h-0">
        {chatContent}
      </TabsContent>
    </Tabs>
  )
}
